import React, { useEffect, useMemo, useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import { API, DOC_COMMERCIAL_LABELS, unwrap, apiMessage, toast, formatAmount, formatDate } from "./projetsCommon";

const ROLE_BADGE = {
    Produit: { css: "badge-success", label: "Produit" },
    Charge: { css: "badge-danger", label: "Charge" },
    "Engagé": { css: "badge-warning", label: "Engagé" },
    Info: { css: "badge-light", label: "Suivi" },
};

/** Onglet « Documents commerciaux » : tous les achats / ventes imputés au projet. */
const ProjetDocumentsCommerciaux = ({ projetId }) => {
    const [docs, setDocs] = useState(null);
    const [sens, setSens] = useState("");

    useEffect(() => {
        axiosInstance.get(API.finances(projetId))
            .then((res) => setDocs(unwrap(res)?.documents || []))
            .catch((error) => { setDocs([]); toast("error", apiMessage(error, "Impossible de charger les documents")); });
    }, [projetId]);

    const filtered = useMemo(() => (docs || []).filter((d) => !sens || d.sens === sens), [docs, sens]);

    if (!docs) return <p>Chargement...</p>;

    return (
        <div className="card">
            <div className="card-header py-2 d-flex justify-content-between align-items-center flex-wrap">
                <div className="btn-group btn-group-sm">
                    {[["", "Tous"], ["Vente", "Ventes"], ["Achat", "Achats"]].map(([v, l]) => (
                        <button key={v} className={`btn ${sens === v ? "btn-secondary" : "btn-outline-secondary"}`} onClick={() => setSens(v)}>{l}</button>
                    ))}
                </div>
                <small className="text-muted">
                    Seuls les documents marqués <span className="badge badge-success">Produit</span> <span className="badge badge-danger">Charge</span>{" "}
                    <span className="badge badge-warning">Engagé</span> entrent dans le calcul ; les autres servent au suivi.
                </small>
            </div>
            <div className="table-responsive">
                <table className="table table-sm table-hover mb-0">
                    <thead className="thead-light">
                        <tr><th>Date</th><th>Type</th><th>Numéro</th><th>Client / Fournisseur</th><th className="text-right">Total HT</th><th>État</th><th>Rôle</th></tr>
                    </thead>
                    <tbody>
                        {filtered.length === 0 && (
                            <tr><td colSpan="7" className="text-center text-muted py-4">
                                Aucun document. Choisissez ce projet dans le champ « Projet » d'un devis, bon de commande ou facture.
                            </td></tr>
                        )}
                        {filtered.map((d) => {
                            const role = ROLE_BADGE[d.role] || ROLE_BADGE.Info;
                            return (
                                <tr key={`${d.documentType}-${d.id}`} className={d.compte ? "" : "text-muted"}>
                                    <td className="small text-nowrap">{formatDate(d.dateDocument)}</td>
                                    <td>
                                        <i className={`fas ${d.sens === "Vente" ? "fa-arrow-up text-success" : "fa-arrow-down text-danger"} mr-1`}></i>
                                        {DOC_COMMERCIAL_LABELS[d.documentType] || d.documentType}
                                    </td>
                                    <td>{d.numero}</td>
                                    <td>{d.tiers || "—"}</td>
                                    <td className="text-right text-nowrap">{formatAmount(d.totalHT)}</td>
                                    <td className="small">{d.etat}{d.statut ? ` · ${d.statut}` : ""}</td>
                                    <td>
                                        <span className={`badge ${role.css}`}>{role.label}</span>
                                        {!d.compte && d.role !== "Info" && <small className="text-muted ml-1">(non compté)</small>}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ProjetDocumentsCommerciaux;
